import React from 'react';
import { useTranslation } from 'react-i18next';

function TaskArticleFields({
  articles = [],
  formData,
  onChange
}) {
  const { t } = useTranslation(['tasks', 'articles', 'common']);
  const selected = articles.find(
    (article) => String(article.id) === String(formData.articleId)
  );
  const unitMode = selected?.unit_mode;
  const showQuantity = unitMode === 'quantity' || unitMode === 'both';

  const unitModeLabel = (mode) => {
    if (mode === 'quantity') return t('articles:unitModeQuantity');
    if (mode === 'time') return t('articles:unitModeTime');
    if (mode === 'both') return t('articles:unitModeBoth');
    return mode || '';
  };

  return (
    <>
      <div className="form-group">
        <label>{t('tasks:articleOptionalLabel')}</label>
        <select
          name="articleId"
          className="tasks-form-select-full"
          value={formData.articleId || ''}
          onChange={onChange}
        >
          <option value="">{t('tasks:selectArticle')}</option>
          {articles.map((article) => (
            <option key={article.id} value={article.id}>
              {article.name} ({unitModeLabel(article.unit_mode)})
            </option>
          ))}
        </select>
        {articles.length > 0 && (
          <small className="tasks-form-hint">{t('tasks:articleOptionalHint')}</small>
        )}
      </div>
      {showQuantity && (
        <div className="form-group">
          <label>{t('tasks:articleQuantityLabel')}</label>
          <input
            type="number"
            name="articleQuantity"
            min="1"
            step="1"
            inputMode="numeric"
            value={formData.articleQuantity || ''}
            onChange={onChange}
          />
          <small className="tasks-form-hint">{t('tasks:articleQuantityHint')}</small>
        </div>
      )}
    </>
  );
}

export default TaskArticleFields;
